import '../../../sass/screens/contact_us/index.scss';
import { initializeForm } from '../../utils/form';
import { initializeRecaptcha } from '../../utils/recaptcha';
import {
  validateIsTrue,
  validateEmail,
  validateMaxLength,
  validateNotEmpty,
} from '../../utils/validators';

$(() => {
  const carousel = $('#country-contact-us-carousel');
  const sliderTop = $('#country-contact-us-carousel-list');
  const sliderBottom = carousel.find('.carousel__display');
  const nextArrow = carousel.find('.carousel__arrow--next');
  const prevArrow = carousel.find('.carousel__arrow--prev');
  const contactUsForm = $('#contact-us-form');
  const policyAcceptInput = contactUsForm.find('input[name="privacy-policy"]');

  sliderTop.slick({
    infinite: true,
    variableWidth: true,
    dots: true,
    mobileFirst: true,
    slidesToShow: 3,
    centerPadding: '60px',
    swipe: false,
    nextArrow,
    prevArrow,
    focusOnSelect: true,
    asNavFor: '#country-contact-us-carousel .carousel__display',
  });

  sliderBottom.slick({
    infinite: true,
    arrows: false,
    fade: true,
    swipe: false,
    mobileFirst: true,
  });

  const onPolicyAcceptChange = ($event) => {
    const { checked } = $event.target;
    policyAcceptInput.val(checked);
  };

  initializeRecaptcha();

  initializeForm(contactUsForm, {
    validate: (values) => {
      const errors = {
        ...validateIsTrue(values, ['privacy-policy']),
        ...validateNotEmpty(values, [
          'country',
          'name',
          'email',
          'phone',
          'phone_code',
          'message',
        ]),
        ...validateEmail(values),
        ...validateMaxLength(values, 'message'),
      };

      const hasErrors = !$.isEmptyObject(errors);
      contactUsForm.find('input[type="submit"]').attr('disabled', hasErrors);
      return errors;
    },
  });

  policyAcceptInput.on('click', onPolicyAcceptChange);
});
